























































































































































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { mapState } from 'vuex';
import ExperiencesPicker from '~/components/lists/ExperiencesPicker.vue';
import ProfileRunSportTag from '~/components/partials/ProfileRunSportTag.vue';
import FlagstartOutline from '~/components/icons/FlagstartOutline.vue';
import FlagendOutline from '~/components/icons/FlagendOutline.vue';
import WarningOutline from '~/components/icons/WarningOutline.vue';
import HeartOutline from '~/components/icons/HeartOutline.vue';
import LightningSolid from '~/components/icons/LightningSolid.vue';
import ReportModal from '~/components/modals/ReportModal.vue';
import LoopOutline from '~/components/icons/LoopOutline.vue';
import DownloadBottomSolid from '~/components/icons/DownloadBottomSolid.vue';
import ConfirmModal from '~/components/modals/ConfirmModal.vue';
import PinOutline from '~/components/icons/PinOutline.vue';
import SpotOutline from '~/components/icons/SpotOutline.vue';
import Dropdown from '~/components/partials/Dropdown.vue';
import LabelsInfos from "~/components/partials/LabelsInfos.vue";
import HandiSolid from "~/components/icons/HandiSolid.vue";
import { difficultyHandle } from "~/utils/explorer";

const Modal: Types.Dictionary<string> = {
  REPORT_MODAL: 'report-modal',
  NEED_LOGIN: 'need-login',
  NEED_LOGIN_DOWNLOAD: 'need-login-download',
};

@Component({
  components: {
    HandiSolid,
    LabelsInfos,
    ProfileRunSportTag,
    ExperiencesPicker,
    FlagstartOutline,
    FlagendOutline,
    WarningOutline,
    HeartOutline,
    LightningSolid,
    ReportModal,
    LoopOutline,
    DownloadBottomSolid,
    ConfirmModal,
    PinOutline,
    SpotOutline,
    Dropdown,
  },
  computed: {
    ...mapState([
      'iframeMode',
    ]),
  },
})
export default class RouteStickyMenu extends Vue {
  @Prop(Object) route: Types.Route;
  @Prop(Array) links: [];
  @Prop(Object) routeSportTag: {};
  @Prop(Number) averageRatesNote: 0;
  @Prop(Array) kpis: [];
  @Prop(String) type: '';
  @Prop(String) locale: '';
  @Prop(String) status: '';

  $refs: {
    options: HTMLButtonElement;
    print: HTMLButtonElement;
  };

  Modal = Modal;
  modal: string = '';

  dropdownOptions: Array<{modalId: string, name: string}> = [
    { modalId: Modal.REPORT_MODAL, name: this.$t('routeStickyMenu.reportModalTitle') },
  ];

  /*
    When user reports a problem in the modal, we emit to page so the API actions
    are done in page
  */
  @Emit('emit-report')
  emitReport (val: { category: string, text: string, media: string[], route_id?: number }) {
    const object = val;
    object.route_id = this.route.id;
    return object;
  }

  /* Checks if user is connected */
  get checkUserConnection () {
    return this.$cookies.get('token');
  }

  /* Returns the list of actions available for user */
  get printOptions () {
    return [
      {
        path: `${this.$slugify(this.route.title)}-${this.route.id}/print`,
        name: this.$t('routeStickyMenu.print'),
      },
      {
        path: '#',
        name: this.$t('routeStickyMenu.gpx'),
      },
    ];
  }

  mounted () {
    // Force modal display to hidden
    this.$root.$on('close-report-modal', () => {
      this.modal = '';
    });
  }

  /*
    This method will fetch associated track of the route. Then we will create a
    GPX file and download it. All the logic is made here and not in page as
    downloading a file is only done here in the app
  */
  async createAndDownloadGpx (path: string) {
    if (path === '#') {
      const gpx = await this.$store.dispatch('explorer/downloadRouteGpx', Number(this.$route.params.routeid.split('-').pop()?.trim()));
      const blob = new Blob([gpx], { type: 'Application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${this.route.title}.gpx`;
      link.click();
      URL.revokeObjectURL(link.href);
    } else {
      window.open(path);
    }
  }

  /* This method pushes the user to signIn page if isn't connected */
  goToSignin () {
    const route: any = this.localePath(`/signin?next=${this.$route.path}`);
    this.$router.push(route);
  }

  difficulty (difficulty: Types.Difficulty) {
    return difficultyHandle(difficulty);
  }

  /* This method updates the style of the scrolled active element */
  onItemChanged (event: Event, currentItem: HTMLElement, lastActiveItem: HTMLElement) {
    if (process.client) {
      if (currentItem && lastActiveItem) {
        document.querySelectorAll('.SubMenuItem')[0]?.classList.remove('active');
        currentItem.classList.add('active');
        lastActiveItem.classList.remove('active');
      } else {
        document.querySelectorAll('.SubMenuItem')[0]?.classList.add('active');
      }
    }
  }
}
